// extracted by mini-css-extract-plugin
export default {"gridContainer":"ProductGrid_gridContainer__1c9yb","productBox":"ProductGrid_productBox__ny2YD","image":"ProductGrid_image__DGhEY","label":"ProductGrid_label__iug56"};